module.exports = __webpack_public_path__ + "img/crown_icon.6ecae584.svg";